import ShareRoundedIcon from '@mui/icons-material/ShareRounded'
import { Box, Tooltip, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import CardAppointment from 'component/Appointment/CardAppointment'
import SectionAppointment from 'component/Appointment/GraphAppointment'
import { imgs, onProfileError } from 'constants/images'
import { AppointmentCardItemDayInterface, AppointmentDisplayDayInterface, AppointmentTags } from 'features/counter/appointment/appointment-interface'
import { getColorStatus } from 'features/counter/doctor-schedule/doctor-schedule'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** UTILS */
import { colors } from 'constants/theme'

import { fileUrl } from 'api/api'
import CardBreak from 'component/Appointment/CardBreak'
import ButtonCustom from 'component/Button/ButtonCustom'
import { ScrollSync, ScrollSyncNode } from 'component/syncScroll'
import { useFormatSizeAppointment } from './appointment'
import { BoxTag } from './style'

const DivProfileDoctor = styled('div')(({ theme }) => ({
  border: `1px solid ${colors.black}`,
  height: '40px',
  width: '40px',
  borderRadius: '50rem',
  margin: '0.25rem',
  overflow: 'hidden',
  '& img': {
    objectFit: 'cover',
    height: '100%',
    width: '100%'
  }
}))

const DivDisplayDay = styled('div')<{ width: string }>(({ theme, width }) => ({
  // overflow: 'auto',
  maxHeight: '100%',
  '& .service-slider-container': {
    '&::-webkit-scrollbar': {
      width: 1,
      height: '7px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: colors.disabledGray,
      borderRadius: 50
    }
    // minWidth: `calc(${listAppointmentDay.length * 435}px + 4.05rem)`
  },
  '& .section-head-doctor': {
    paddingTop: '1rem',
    // paddingLeft: '3.05rem',
    // width: `calc(${listAppointmentDay.length * 435}px + 3.05rem)`,
    zIndex: 300,
    '& .profile-doctor': {
      border: `1px solid ${colors.lightGray}`,
      height: '40px',
      width: '40px',
      borderRadius: '50rem',
      margin: '0.25rem',
      overflow: 'hidden',
      '& img': {
        objectFit: 'cover',
        height: '100%',
        width: '100%'
      }
    }
  },
  '& .section-body-appointment': {
    // paddingLeft: '3.05rem',
    // width: `calc(${listAppointmentDay.length * 435}px + 4.05rem)`,
    // overflow: 'auto',
    '.layout-schedule': {
      overflow: 'hidden'
    },
    '& .graph-appointment': {
      width: `${width}`,
      display: 'inline-block',
      margin: '0 0.05rem 0 0.05rem'
    }
  },
  '& .div-time': {
    width: 48,
    display: 'inline-block',
    position: 'sticky',
    marginTop: 88,
    // overflow: 'auto',
    maxHeight: '100%'
  }
}))

const CardDoctor = styled('div')<{ width: string }>(({ theme, width }) => ({
  display: 'inline-block',
  width: `${width}`,
  minHeight: '100px',
  height: '100%',
  border: `1px solid ${colors.lightGray}`,
  margin: '0 0.05rem 0 0.05rem',
  background: colors.filterDropdown,
  position: 'relative',
}))


export interface DisplayDayProps {
  branchId: number
  branch: string
  listAppointmentDay: AppointmentDisplayDayInterface[]
  timeRange: any[]
  onEdit?: (id: number) => void
  onEditSpecialInfo?: (id: number) => void
  clinicIsClose: boolean
  type?: string
  formAppointmentWidth?: number
  onClickShare?: (doctor: any) => void
}

type FixPositionType = {
  top: number;
  left: number;
};

const getPatientCode = (branch: any, ap: AppointmentCardItemDayInterface): string | undefined => {
  if (branch?.patientCodeAppointment === '1') return ap.cnNumber
  if (branch?.patientCodeAppointment === '0') return ap.branchCnNumber
  if (branch?.patientCodeAppointment === '2') return ap.snCode
  return undefined
}

const isRangeEndAfterTimeOut = (rangeText: string, timeOutText: string): boolean => {
  const [startRaw, endRaw] = rangeText.split(' - ').map(s => s.trim())
  const start = moment(startRaw.replace(/\./g, ':'), 'HH:mm')
  const end = moment(endRaw.replace(/\./g, ':'), 'HH:mm')
  if (!end.isAfter(start)) end.add(1, 'day')
  const timeOut = moment(timeOutText, 'HH:mm')
  if (timeOut.isBefore(start)) timeOut.add(1, 'day')
  return end.isAfter(timeOut)
}

const groupAppointmentByHour = (apt: any) => {
  return _.chain(apt)
    .groupBy('start')
    .map((value: any) => ({ data: value }))
    .value()
}

export default function DisplayDay(props: DisplayDayProps) {
  const { t, i18n } = useTranslation()
  const [viewDetails, setViewDetails]: any = useState({})
  const branch = props.branch as any
  const widthCardAppointment = useFormatSizeAppointment()

  const [position, setPosition] = useState<FixPositionType | null>(null);
  const idSuffix = props.type === 'share' ? '-share' : '';

  const groupedByDoctor = useMemo(() => {
    return props.listAppointmentDay.map(lad => groupAppointmentByHour(lad.appointments))
  }, [props.listAppointmentDay])

  const scrollTabDoctor = useCallback(() => {
    const tabDoctor: any = document.getElementById("service-slider-container");
    document.getElementById("layout-schedule")?.scrollTo(0, tabDoctor?.scrollTop)
  }, [])

  const renderImgDoctor = useCallback((lad: AppointmentDisplayDayInterface) => {
    if (lad?.doctorProfile && !lad?.doctorProfile?.includes("simple-user-profile.png")) {
      return `${fileUrl}/${lad.doctorProfile}`
    }
    return imgs.defaultAvatar
  }, [])


  return (
    // แสดงตารางนัดเมื่อคลินิกเปิด หรือมีนัดในวันนั้นจริง (กันเคสวันคลินิกปิดแต่มีนัด/หมอเข้าเวร) — เคส UR-2605-0184
    (!props.clinicIsClose || props.listAppointmentDay.length > 0) && (
      <DivDisplayDay
        className="display-days position-relative d-flex flex-column"
        width={`${widthCardAppointment}px`}
      >
        <ScrollSync proportional={false}>
          <Box className='overflow-auto' style={{ display: 'flex', position: 'relative', height: '100%' }}
            sx={{
              "#layout-schedule::-webkit-scrollbar": {
                width: '0px',
                height: '0px',
              },
              '.div-time': {
                paddingTop: '28px',
                marginBottom: '28px'
              },
              '.layout-schedule': {
                overflowY: 'hidden !important'
              }
            }}>
            <ScrollSyncNode group="day" onScroll={scrollTabDoctor}>
              <div id={`div-time${idSuffix}`} className={'div-time none-scroll'}>
                {props.listAppointmentDay.length > 0 && (
                  <SectionAppointment branchId={1} timeRange={props.timeRange} isShowTime={true} enableTimeTooltip showMinute />
                )}
              </div>
            </ScrollSyncNode>
            <ScrollSyncNode group={`day${idSuffix}`} onScroll={scrollTabDoctor}>
              <div id={`service-slider-container${idSuffix}`} className="service-slider-container overflow-scroll" >
                <div id={`service-slider-wrap${idSuffix}`} className="service-slider-wrap">
                  <Box
                    className="section-head-doctor sticky-top bg-white d-flex flex-row"
                    style={{ width: 'fit-content' }}
                    sx={{
                      '.doctor-bg:nth-child(even)': {
                        background: colors.appointmentDoctor.colorEven,
                      },
                      '.doctor-bg:nth-child(odd)': {
                        background: colors.appointmentDoctor.colorOdd,
                      }
                    }}
                  >
                    {_.map(props.listAppointmentDay, (lad: AppointmentDisplayDayInterface, i: number) => (
                      <CardDoctor key={i} className='doctor-bg' width={`${widthCardAppointment}px`}>
                        {props.type !== 'share' && branch?.showAppointmentSharing === '1' && (<Box
                          sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}>
                          <ButtonCustom
                            style={{ backgroundColor: colors.white }}
                            textButton={t('DOCTOR_SCHEDULE.BUTTON.SHARE')}
                            type="button"
                            variant="outlined"
                            startIcon={<ShareRoundedIcon />}
                            onClick={() => props.onClickShare && props.onClickShare(lad)}
                          />
                        </Box>
                        )}
                        <Box color='white' paddingLeft="8px" paddingRight="16px" paddingTop="4px" height="20px" display="flex" alignItems="center" borderRadius="0px 0px 8px 0px" sx={{ width: 'fit-content', maxWidth: '100%', backgroundColor: '#1CB99A' }}>
                          <Tooltip title={lad[`servicePointName${i18n.language !== "th" ? "En" : ""}`]} placement={'top-start'} >
                            <Typography paddingBottom="2px" fontSize="11px">{lad.servicePointName ? lad[`servicePointName${i18n.language !== "th" ? "En" : ""}`] : 'ไม่ระบุห้องตรวจ'}</Typography>
                          </Tooltip>
                        </Box>
                        <Row className="mx-0" style={{ paddingTop: '4px', width: `${widthCardAppointment}px` }}>
                          <Col sm={'auto'} className={'text-nowrap overflow-hidden w-auto'}>
                            <DivProfileDoctor className="profile-doctor">
                              <img src={renderImgDoctor(lad)} onError={onProfileError} alt={lad?.doctorFullname} />
                            </DivProfileDoctor>
                          </Col>
                          <Col className={'px-0 text-nowrap overflow-hidden'}>
                            <p className="mb-0 d-flex align-items-center">
                              <Tooltip title={<div>{lad.doctorFullname}</div>} placement={'top-start'}>
                                <strong>{lad.doctorFullname}</strong>
                              </Tooltip>
                            </p>
                            {lad?.tags?.length ?
                              <BoxTag>
                                {lad?.tags.map((item: AppointmentTags, index: number) => {
                                  return (
                                    <Box
                                      key={index}
                                      title={item.tagName}
                                      className={`items-tag`}
                                      sx={{ backgroundColor: item.color, }}
                                    />
                                  )
                                })}
                              </BoxTag>
                              : <></>
                            }
                            <span className="fz-14">
                              <span className='pr-1'>{t('HOME.TITLE.START_WORK')}</span>
                              {lad?.statusDoctorSchedule === "NORMAL" && (
                                `${lad.doctorSchedule} ${i18n.language === "th" ? 'น.' : ''} (${lad.countAppointment})`
                              ) || (
                                  <span style={{ color: getColorStatus(lad?.statusDoctorSchedule || '', 'COLOR') }}>{lad?.statusDoctorSchedule ? `(${t(`DOCTOR_SCHEDULE.STATUS.${lad?.statusDoctorSchedule}`)})` : '-'}</span>
                                )}
                            </span>
                          </Col>
                        </Row>
                      </CardDoctor>
                    ))}
                  </Box>
                  <div id={`section-body-appointment${idSuffix}`} className="section-body-appointment d-flex flex-row">
                    {_.map(props.listAppointmentDay, (lad: AppointmentDisplayDayInterface, i: number) => {
                      const grouped = groupedByDoctor[i]
                      return (
                        <div key={i} className={'graph-appointment'} style={{ width: `${widthCardAppointment}px` }}>
                          <SectionAppointment
                            enableTimeTooltip
                            branchId={1}
                            width={widthCardAppointment}
                            isShowTime={false}
                            showMinute
                            timeRange={props.timeRange}
                            hideDot={i > 0}
                            card={
                              _.map(grouped, (time) => {
                                const byDoctor = _.groupBy(time.data, 'doctorId')
                                return _.map(time.data, (ap: AppointmentCardItemDayInterface, j: number) => {
                                  const sameDoctor: AppointmentCardItemDayInterface[] = byDoctor[ap.doctorId] || []
                                  const allRow = sameDoctor.length
                                  const count = sameDoctor.indexOf(ap) + 1
                                  const patientCode = getPatientCode(branch, ap)

                                  return (
                                    <CardAppointment
                                      key={j}
                                      appointmentId={ap.appointmentId}
                                      status={ap.statusAppointment}
                                      branchCnNumber={patientCode || ''}
                                      colorBackground={ap.color}
                                      serviceText={ap.serviceText}
                                      services={ap.services}
                                      showOperativeColor={branch?.showOperativeColor === '1'}
                                      patientFullName={ap.patientFullname}
                                      displayName={ap.displayName}
                                      prefixNameEn={ap.prefixNameEn}
                                      firstnameEn={ap.firstnameEn}
                                      lastnameEn={ap.lastnameEn}
                                      rangeTimeText={ap.rangeTimeText}
                                      start={
                                        moment(ap.start, 'HH:mm')
                                          .add(count - 1)
                                          .format('HH:mm') || ap.rangeTimeText.split(' - ')[0].replace('.', ':')
                                      }
                                      end={
                                        isRangeEndAfterTimeOut(ap?.rangeTimeText, branch?.timeOut) ? moment(branch?.timeOut, 'HH:mm').add(20, 'minutes').format('HH:mm') : ap.end || ap.rangeTimeText.split(' - ')[1].replace('.', ':')
                                      }
                                      hasLab={ap.hasLab === 'HAS'}
                                      hasXray={ap.hasXray === 'HAS'}
                                      onViewDetail={props.type !== 'share' ? () => setViewDetails(() => ({ isShow: true, ...ap })) : _.noop}
                                      onPosition={props.type !== 'share' ? (translateY, translateX) => setPosition({ top: translateY, left: translateX }) : _.noop}
                                      timeStart={props.timeRange[0]}
                                      width={(widthCardAppointment / allRow)}
                                      countThis={count}
                                      translateX={(widthCardAppointment / allRow) * j}
                                      specialInfo={ap?.specialInfo}
                                      type={props.type}
                                      phone={ap?.phone}
                                      allRow={allRow >= 4}
                                      viewDetails={viewDetails}
                                      branch={props.branch}
                                      position={position}
                                      onEdit={props.onEdit}
                                      onEditSpecialInfo={props.onEditSpecialInfo}
                                      timeRange={props.timeRange}
                                      setViewDetail={setViewDetails}
                                    />
                                  )
                                })
                              })
                            }
                            break={
                              <CardBreak
                                start={moment(lad.breakTimeStart, 'HH:mm').format('HH:mm')}
                                end={lad.breakTimeEnd}
                                timeStart={props.timeRange[0]}
                                width={widthCardAppointment}
                                translateX={widthCardAppointment}
                              />
                            }
                          />
                        </div>
                      )
                    })}
                  </div>

                </div>
              </div>
            </ScrollSyncNode>
          </Box>
        </ScrollSync>

      </DivDisplayDay>
    ) || (
      <Typography className='text-center my-4' sx={{ fontWeight: 500, color: colors.textLightGray }}>{t('CLINIC_CLOSE')}</Typography>
    )
  )
}
